import axios from 'smg/axios';
import * as session from 'smg/customer-api/session';
import { HandleRequestError } from 'smg/errors';
import * as models from 'smg/models';
import * as template from 'smg/template';
import * as toast from 'smg/toast';
import { Relref } from '../hugo';

declare interface flagResp {
    flagIDs?: models.FlagID[];
}

export default async function main() {
    if (await session.Redirect(undefined, Relref('/login'))) {
        return;
    }

    const flagIDs = [
        {
            flagID: models.FlagID.FLAG_PREFERS_SMS,
            text: 'Opt in to receive SMS notifications.',
        },
    ];

    const userActiveFlags: models.FlagID[] = await axios.get<flagResp>('/users/flags').then(resp => resp.data.flagIDs) || [];

    const $ = document.querySelector('#checkboxes-container') as HTMLElement;

    for (const flag of flagIDs) {
        const $container = template.Clone('#checkbox-template').firstElementChild as HTMLElement;
        const $checkbox = $container.querySelector('.form-check-input') as HTMLInputElement;
        const $span = $container.querySelector('.checkbox-label') as HTMLElement;
        const $alert = $container.querySelector('.text-success') as HTMLElement;
        $span.textContent = flag.text;

        if (userActiveFlags.includes(flag.flagID)) {
            $checkbox.checked = true;
        } else {
            $checkbox.checked = false;
        }

        $checkbox.addEventListener('click', async e => {
            e.preventDefault();

            let fn;

            $checkbox.disabled = true;
            $span.classList.add('text-muted');
            $alert.style.opacity = '0';

            if (!$checkbox.checked) {
                fn = axios.delete(`/flags/${flag.flagID}`);
            } else {
                fn = axios.post(`/flags/${flag.flagID}`);
            }

            await fn.then(() => {
                $alert.style.opacity = '1';
                $checkbox.disabled = false;
                if ($checkbox.checked) {
                    $checkbox.checked = false;
                } else {
                    $checkbox.checked = true;
                }
                $span.classList.remove('text-muted');
                toast.Success('Successfully updated notification settings.');
            }).catch(err => {
                HandleRequestError(err);
                $span.classList.remove('text-muted');
                $checkbox.disabled = false;
            });
        });

        $.append($container);
    }

    const $spinner = document.querySelector('#checkboxes-spinner') as HTMLElement;
    $spinner.classList.add('d-none');
}